<template>
  <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible"
    @closed="reset">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="auto">
      <el-form-item label="服务器" prop="host_id" :label-width="formLabelWidth">
        <el-select v-model="dataForm.host_id" placeholder="请选择服务器" filterableclass="fw">
          <el-option
            v-for="item of groupTypeList"
            :key="item.id"
            :value="item.id"
            :label="item.name +' ('+ item.hostname  +') - RDP'" />
        </el-select>
      </el-form-item>
        <el-form-item label="远程账户" :label-width="formLabelWidth" prop="username">
          <el-input v-model="dataForm.username" autocomplete="off" />
        </el-form-item>
        <el-form-item label="用户密码" :label-width="formLabelWidth" prop="password">
          <el-input v-model="dataForm.password" autocomplete="off" />
        </el-form-item>
        <el-form-item label="关联账户" :label-width="formLabelWidth" prop="account_id">
          <el-cascader
            :options="options"
            v-model="dataForm.account_id"
            :props="{emitPath: false, expandTrigger: 'hover' }"
            filterable
            clearable />
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth" prop="is_lock">
          <el-radio-group v-model="dataForm.is_lock">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">锁定</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
          <el-input v-model="dataForm.remark" autocomplete="off" />
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { eventBus } from '@containers/WinRD/utils/eventBus' // 全局事件总线

export default {
  data () {
    return {
      visible: false,
      submitLoading: false,
      appTypeList: [],
      groupTypeList: [],
      linkUserList: [],
      is_lock: [
        { id: 0, name: '正常' },
        { id: 1, name: '异常' },
      ],
      dataForm: {
        host_id: '',
        username: '',
        password: '',
        account_id: null,
        is_lock: 0,
        remark: '',
      },
      dataRule: {
        host_id: [{
          required: true,
          message: '请选择服务器',
          trigger: 'blur',
        }],
        username: [{
          required: true,
          message: '请输入远程账户名',
          trigger: 'blur',
        }],
        password: [{
          required: true,
          message: '请输入远程账户密码',
        }],
        account_id: [{
          required: true,
          message: '请选择关联账户',
          trigger: 'blur',
        }],
      },
    }
  },
  methods: {
    init (row, appTypeList) {
      this.visible = true
      this.appTypeList = appTypeList
      this.servefetchData() // 获取服务器列表
      this.linkUser() // 获取关联账户列表
    },
    reset () {
      this.$refs.dataForm.resetFields()
    },

    // 服务器列表获取
    async servefetchData () {
      try {
        const dataRaw = {
          page: 1,
          per_page: 100,
        }

        const response = await this.$http.get('/rdbackend/list_remote_hosts', {
          params: dataRaw,
        })

        this.groupTypeList = response.data.remote_hosts || []
      } catch (error) {
        console.error('There was an error!', error)
      }
    },

    // 关联账户列表获取
    async linkUser () {
      try {
        const response = await this.$http.get('/rdbackend/get_users')

        // 确保 response.data 是一个数组
        this.linkUserList = Array.isArray(response.data.data) ? response.data.data : []
        console.log(response.data)

        // 处理 options 数据
        this.options = this.linkUserList.map(domain => ({
          value: domain.domain_id,
          label: domain.project_domain,
          children: domain.user ? domain.user.map(user => ({
            value: user.id,
            label: user.displayname || user.name,
          })) : [],
        }))
      } catch (error) {
        console.error('There was an error!', error)
      }
    },

    // 表单提交
    async dataFormSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const tmp = { ...this.dataForm }

          this.$http.post('/rdbackend/add_user', tmp, {
            headers: {
              'Content-Type': 'application/json',
            },
          }).then(response => {
            this.visible = false
            this.submitLoading = false
            this.$message({
              message: response.data.message,
              type: 'success',
              duration: 1500,
            })
            // 触发事件
            eventBus.$emit('refresh-list')
          }).catch(error => {
            this.$message({
              message: error.response.data.error,
              type: 'error',
              duration: 1500,
            })
            this.submitLoading = false
          })
        }
      })
    },
  },
}
</script>
